import {Injectable, isDevMode} from '@angular/core';
import {TurnsDaoService} from '../../../dao/turns-dao-services/turns-dao-service/turns-dao.service';
import {Observable} from 'rxjs/internal/Observable';
import {Subject} from 'rxjs';
import {ControlDesk} from '../../../models/turns-models/control-desk.model';
import {LocationDesk} from '../../../models/turns-models/location-desk.model';
import {PendingTurn} from '../../../models/turns-models/pending-turn.model';

@Injectable({
  providedIn: 'root'
})
export class TurnsService {

  private DATA = 'data';

  updateDesksListener = new Subject<any>();
  advanceTurnListener = new Subject<any>();
  deskAdvanceObjectListener = new Subject<any>();
  turnTakenListener = new Subject<any>();

  constructor(private turnsDaoService: TurnsDaoService) {}

  public getControlDesks() {
    return Observable.create(
      (o) => {
        this.turnsDaoService.getControlDesks().subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            const desks = new Array<ControlDesk>();
            res[this.DATA]['desks'].forEach(
              (d) => {
                desks.push(Object.assign(new ControlDesk(), d));
              }
            );
            o.next(desks);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public changeDeskStatus(internalId: string, status: boolean) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.changeDeskStatus(internalId, status).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            status = res[this.DATA]['status'];
            o.next(status);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public pushTurn(deskId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.pushTurn(deskId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public callNextDeskLocation(internalId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.callNextDeskLocation(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public callNextDeskLocationTurn(locationInternalId: string, turnInternalId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.callNextDeskLocationTurn(locationInternalId, turnInternalId
        ).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public addTurnInformation(body: any) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.addTurnInformation(body).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(status);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public callBackLastTurn(deskId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.callBackLastTurn(deskId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public callbackLastLocationTurn(internalId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.callbackLastLocationTurn(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public requeueTurn(internalId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.requeueTurn(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public transfer(turnInternalId: string, turnDeskInternalId: string | null, locationInternalId: string | null, mode: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.transfer(turnInternalId, turnDeskInternalId, locationInternalId, mode).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public finishAttendance(turnDeskInternalId: string | null, locationInternalId: string | null) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.finishAttendance(turnDeskInternalId, locationInternalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public getCompanyInfo(internalId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.getCompanyInfo(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res[this.DATA]);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public callOpenDeskLocation(internalId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.openDeskLocation(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res[this.DATA]);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public callCloseDeskLocation(internalId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.closeDeskLocation(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res[this.DATA]);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public updateCurrentLocation(internalId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.deskLocationCurrently(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res[this.DATA]);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public updateCurrentDesk(internalId: string) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.deskCurrently(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res[this.DATA]);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  // UPDATE TURNS
  public listenUpdateDesks() {
    return this.updateDesksListener.asObservable();
  }

  public updateDesks() {
    this.updateDesksListener.next();
  }

  // TURNS
  public listenAdvanceTurn() {
    return this.advanceTurnListener.asObservable();
  }

  public advanceTurn(data) {
    this.advanceTurnListener.next(this.parseString(data));
  }

  public listenDeskAdvanceObject() {
    return this.deskAdvanceObjectListener.asObservable();
  }

  public deskAdvanceObject(data) {
    this.deskAdvanceObjectListener.next(data);
  }

  public listenTurnTaken() {
    return this.turnTakenListener.asObservable();
  }

  public turnTaken() {
    this.turnTakenListener.next();
  }

  private parseString(data) {
    const parsed = data.split(';');
    const internalId = parsed[0];
    const turnDeskCurrentTurn = parsed[1];
    const turnDeskPositionName = parsed[2];
    return { updatedDesk : { internalId, turnDeskCurrentTurn, turnDeskPositionName} };
  }

  public getDeskLocations() {
    return Observable.create(
      (o) => {
        this.turnsDaoService.getDeskLocations([]).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            const desks = new Array<LocationDesk>();
            res[this.DATA]['deskLocationList'].forEach(
              (d) => {
                desks.push(Object.assign(new LocationDesk(), d));
              }
            );
            o.next(desks);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public getTurnsWaiting(internalId: any, internalIdLocation: any) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.getTurnsWaiting(internalId, internalIdLocation).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            const turns = new Array<PendingTurn>();
            res[this.DATA]['turnList'].forEach(
              (t) => {
                const turn: PendingTurn = {
                  turnListinternalId: t['turnListinternalId'],
                  turn: t['turn'],
                  centerName: t['centerName'],
                  deskName: t['deskName'],
                  turnLocation: t['turnLocation'],
                  turnType: t['turnType'],
                  customerName: t['customerName'],
                  customerSurname: t['customerSurname'],
                  formName: t['formName'],
                  turnDate: t['turnDate'],
                  attendingDateTimezone: t['attendingDateTimezone'],
                  waitingTimeSeconds: t['secondsInWaiting']
                };
                turns.push(turn);
              }
            );
            o.next(turns);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public getControlAllDesks() {
    return Observable.create(
      (o) => {
        this.turnsDaoService.getControlAllDesks().subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            const desks = new Array<ControlDesk>();
            res[this.DATA]['desks'].forEach(
              (d) => {
                desks.push(Object.assign(new ControlDesk(), d));
              }
            );
            o.next(desks);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public callNextDueToAbsence(internalId: any) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.callNextDueToAbsence(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res[this.DATA]);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public pushTurnDueToAbsence(internalId: any) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.pushTurnDueToAbsence(internalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res[this.DATA]);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

  public attendWithoutTurn(turnDeskInternalId: any, locationInternalId: any | null) {
    return Observable.create(
      (o) => {
        this.turnsDaoService.attendWithoutTurn(turnDeskInternalId, locationInternalId).subscribe(
          (res) => {
            if (isDevMode()) { console.dir(res); }
            o.next(res[this.DATA]);
          },
          (error) => {
            o.error(error);
          }
        );
      }
    );
  }

}
